export default state => state.weblabs;
